import React, { Fragment, useState, useEffect } from 'react';

import { Formik, Field, FieldArray } from 'formik';
import * as Yup from 'yup';

import TrashIcon from 'Assets/icons/trash.svg';

const EvaluationTemplateCreateSchema = Yup.object().shape({
    companies: Yup.array().of(
        Yup.object({
            name: Yup.string()
                .required($t('This value is required')) // Makes sure the name is required
                .min(2, $t('The name must contain at least 2 characters')) // Ensures the name has at least 2 characters
                .max(191, $t('The name must be no more than 191 characters')), // Ensures the name is not longer than 191 characters
        }),
    ),
});

export default function EvaluationTemplateUpdateForm(props) {
    const [companies, setCompanies] = useState([]);
    const [showForm, setShowForm] = useState(false);
    const [isSubmittedSuccessfully, setIsSubmittedSuccessfully] = useState(false);
    const [isSubmittedFailed, setIsSubmittedFailed] = useState(false);
    const fetchCompanies = () => {
        axios
            .get(props.companiesIndexUrl)
            .then((res) => {
                setCompanies(res.data.companies);
                setShowForm(true);
            })
            .catch((error) => {
                setCompanies([]);
            });
    };

    useEffect(() => fetchCompanies(), []);

    return (
        <>
            {isSubmittedSuccessfully && <div className="alert alert-success">{$t('Companies have been updated successfully')}</div>}
            {isSubmittedFailed && <div className="alert alert-danger">{$t('Failed to update companies')}</div>}
            {showForm && (
                <Formik
                    initialValues={{
                        companies: companies,
                    }}
                    validationSchema={EvaluationTemplateCreateSchema}
                    onSubmit={(values, actions) => {
                        axios
                            .put(props.companiesUpdateUrl, values)
                            .then((res) => {
                                setCompanies(res.data.companies);
                                actions.setFieldValue('companies', res.data.companies);

                                setIsSubmittedSuccessfully(true);
                                setTimeout(() => {
                                    setIsSubmittedSuccessfully(false);
                                }, 3000);
                            })
                            .catch((error) => {
                                setIsSubmittedFailed(true);
                                setTimeout(() => {
                                    setIsSubmittedFailed(false);
                                }, 3000);
                            })
                            .finally(() => {
                                actions.setSubmitting(false);
                            });
                    }}
                >
                    {({ values, errors, touched, isSubmitting, handleSubmit, setFieldValue, resetForm }) => (
                        <div className="inbud-card tw-mb-3">
                            <FieldArray
                                name="companies"
                                render={(arrayHelpers) => (
                                    <div>
                                        {values.companies && values.companies.length > 0 ? (
                                            values.companies.map((company, index) => (
                                                <Fragment key={index}>
                                                    <div className="tw-grid tw-grid-flow-col tw-auto-cols-fr tw-gap-x-3 tw-mt-6">
                                                        <div className="tw-grid tw-gap-4 tw-grid-cols-2">
                                                            <label className="tw-col-span-1 tw-text-base tw-flex tw-items-center tw-mb-0">
                                                                {$t('Company Name')} {index + 1} <span className="tw-text-red-500">*</span>
                                                            </label>
                                                            <div className={'tw-flex tw-flex-row'}>
                                                                <Field
                                                                    type="text"
                                                                    className={`tw-w-full tw-rounded-lg tw-bg-input-background tw-text-input-text tw-font-semibold tw-border-0 ${
                                                                        errors.companies &&
                                                                        errors.companies[index] &&
                                                                        ((touched.company && touched.company[index]) ||
                                                                            (touched.companies && touched.companies[index]))
                                                                            ? 'tw-border tw-border-red-500'
                                                                            : ''
                                                                    }`}
                                                                    name={`companies.${index}.name`}
                                                                    placeholder={$t('Company Name')}
                                                                />
                                                                <button
                                                                    className="tw-flex tw-flex-col tw-ml-2 tw-justify-center tw-items-center tw-text-xs"
                                                                    onClick={() => arrayHelpers.remove(index)}
                                                                >
                                                                    <TrashIcon className="tw-text-red-500 tw-w-3 tw-h-3" />
                                                                </button>
                                                            </div>
                                                            {errors.companies &&
                                                                errors.companies[index] &&
                                                                errors.companies[index].name &&
                                                                touched.companies &&
                                                                touched.companies[index] && (
                                                                    <div className="tw-col-start-2 tw-text-red-500">{errors.companies[index].name}</div>
                                                                )}
                                                        </div>
                                                    </div>
                                                    {values.companies.length - 1 === index && (
                                                        <div className={'tw-flex tw-flex-row tw-justify-end tw-mt-3'}>
                                                            <button type="button" className="button primary" onClick={() => arrayHelpers.push('')}>
                                                                {$t('Add a company')}
                                                            </button>
                                                        </div>
                                                    )}
                                                </Fragment>
                                            ))
                                        ) : (
                                            <>
                                                <p className={'tw-text-base'}>{$t('There are no Tenderers at this evaluation template')}</p>
                                                <div className={'tw-flex tw-flex-row tw-justify-end tw-mt-3'}>
                                                    <button type="button" className="button primary" onClick={() => arrayHelpers.push('')}>
                                                        {$t('Add a company')}
                                                    </button>
                                                </div>
                                            </>
                                        )}
                                        <div className="tw-mt-3">
                                            <button
                                                type="button"
                                                className="button primary"
                                                disabled={isSubmitting || values.companies.length === 0}
                                                onClick={handleSubmit}
                                            >
                                                {$t('Submit')}
                                            </button>
                                        </div>
                                    </div>
                                )}
                            />
                        </div>
                    )}
                </Formik>
            )}
        </>
    );
}
